import { takeLatest, call, put } from 'redux-saga/effects';

import api from '../api';
import {
    listStatsRequest,
    listStatsSuccess,
    listStatsFailure,
    ChartResponse,
    StatResponse,
    listStatsChartRequest,
    listStatsChartSuccess,
    listStatsChartFailure,
} from './actions';

// API calls
const listStatApi = async (period: string): Promise<StatResponse> => {
    let params = new URLSearchParams({ period: period}).toString();

    const response = await api.get('/main/api/stats/?' + params);
    return response.data;
};

const listStatChartApi = async (period: string): Promise<ChartResponse> => {
    let params = new URLSearchParams({ period: period}).toString();

    const response = await api.get('/main/api/stats/chart/?' + params);
    return response.data;
};

// Sagas
function* handleListStat(action: ReturnType<typeof listStatsRequest>) {
    try {
        const data: StatResponse = yield call(listStatApi, action.payload.period);
        yield put(listStatsSuccess(data));
    } catch (error: any) {
        yield put(listStatsFailure(error.response?.data || 'Failed to list stats'));
    }
}

function* handleListStatChart(action: ReturnType<typeof listStatsChartRequest>) {
    try {
        const data: ChartResponse = yield call(listStatChartApi, action.payload.period);
        yield put(listStatsChartSuccess(data));
    } catch (error: any) {
        yield put(listStatsChartFailure(error.response?.data || 'Failed to list stats'));
    }
}

// Watcher sagas
export function* watchStatsSaga() {
    yield takeLatest(listStatsRequest.type, handleListStat); // Listen for list stats request
    yield takeLatest(listStatsChartRequest.type, handleListStatChart); // Listen for list stats request
}
